import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { useHistory } from 'react-router-dom';
import { hasRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import AccountRolloverTemplate from '.';

const useStyles = buildUseStyles('AccountRolloverWizardStepTemplate', () => ({
  root: {},
}));

const AccountRolloverWizardStepTemplate = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      // Fallthrough case - unsure where to navigate to go to dashboard
      history.push('/');
    }
  };

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      layout={AccountRolloverTemplate}
      primaryActionLabel={'Submit'}
      LayoutProps={{
        resource,
      }}
      onClose={onClose}
      hideErrors
    />
  );
};

AccountRolloverWizardStepTemplate.defaultProps = {
  className: '',
};

AccountRolloverWizardStepTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AccountRolloverWizardStepTemplate;
